import { InputFormTypes } from '@taxdown/piccolo-web';

export const model = {
  password: {
    id: 'password',
    label: 'Auth.resetPassword.label',
    placeholder: '',
    type: InputFormTypes.PASSWORD,
    validations: {
      required: true,
    },
  },
};
